// extracted by mini-css-extract-plugin
module.exports = {"path_blue":"LinkForBranch_path_blue__kvQ19"};